function initKakaoLogin() {
  if (!Kakao.isInitialized()) {
    Kakao.init("fb613a08daa5770438ccdcdd7d888c1c");
    console.log("Kakao Login Initialized : ", Kakao.isInitialized());
  }
}

function kakaoLogin(mainUrl, reAuth) {
  let redirectUri = `${mainUrl}/social-connect?snsName=kakao`;
  const windowFeatures =
    "titlebar=1, resizable=1, scrollbars=yes, width=600, height=800";
  if (reAuth) {
    redirectUri += `&reAuth=${reAuth}`;
  }
  window.open(redirectUri, "", windowFeatures);
}

function initNaverLogin(mainUrl) {
  console.log("init Naver");
  naverLogin = new naver.LoginWithNaverId({
    clientId: "UqZVV7eM6U3mS905iSSS",
    callbackUrl: `${mainUrl}/social-connect`,
    isPopup: true,
    callbackHandle: true,
  });
  naverLogin.init();
  naverLogin.logout();
  $("#naverIdLogin_loginButton").removeAttr("href");

  naverLogin.getLoginStatus(function (status) {
    if (status) {
      const email = naverLogin.user.getEmail();
      const name = naverLogin.user.getName();
      setCookie("NVTK", naverLogin.accessToken.accessToken, 3600);
      if (!email || !name) {
        alert("이메일, 이름은 필수 정보입니다. 정보제공에 동의해주세요.");
        naverLogin.reprompt();
        return;
      }
      if (window.opener) {
        window.opener["angularComponentRef"].zone.run(() => {
          window.opener["angularComponentRef"].loginResult({
            socialKeyTypeCode: "Naver",
            emailAddress: email,
            name: name,
            socialToken: naverLogin.accessToken.accessToken,
          });
        });
        window.close();
      } else {
        var loginOrigin = window.sessionStorage.getItem('loginOrigin');
        window.sessionStorage.setItem('loginResult', JSON.stringify({
          socialKeyTypeCode: "Naver",
          emailAddress: email,
          name: name,
          socialToken: naverLogin.accessToken.accessToken,
        }));
        if (loginOrigin == null) loginOrigin = "login";
        window.location.href = `${mainUrl}/${loginOrigin}?webview=true`;
      }
    } else {
      if (window.naverLogin 
        && window.naverLogin.user
        && window.naverLogin.accessToken
      ) {
        alert(window.naverLogin.user.errorMessage ? window.naverLogin.user.errorMessage : "Login naver fail, please try again");
        if (window.opener) {
          window.close();
        } else {
          window.location.href = `${mainUrl}/login?webview=true`;
        }
      }
    }
  });
}

function initFacebookSDK(appId) {
  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  })(document, "script", "facebook-jssdk");
  window.fbAsyncInit = function () {
    FB.init({
      appId: appId,
      cookie: true, // enable cookies to allow the server to access
      // the session
      xfbml: true, // parse social plugins on this page
      version: "v21.0", // Specify the Graph API version to use
    });
  };
}

function checkLoginState() {
  FB.getLoginStatus(function (response) { });
}

function facebookLogin() {
  FB.login(
    function (response) {
      if (response.status === "connected") {
        accessToken = response.authResponse.accessToken;
        FB.api(
          "/me",
          {
            fields: "name,email",
          },
          function (response) {
            window["angularComponentRef"].zone.run(() => {
              window["angularComponentRef"].loginResult({
                socialKeyTypeCode: "Facebook",
                emailAddress: response.email,
                name: response.name,
                socialToken: accessToken,
              });
            });
          }
        );
      } else if (response.status === "not_authorized") {
        // The person is logged into Facebook, but not your app.
      }
    },
    {
      scope: "email,public_profile",
      return_scopes: true,
    }
  );
}

function initAppleLogin(mainUrl, clientId) {
  AppleID.auth.init({
    clientId,
    scope: "name email",
    redirectURI: `${mainUrl}/social-connect`,
    // redirectURI: `https://dev-www.ohmytrip.com/social-connect`,
    usePopup: true, //or false defaults to false
  });
}

function setCookie(name, value, minutes) {
  var expires = "";
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// function initGoogleLogin(from) {
//   console.log("init Google");
//   // google.accounts.id.initialize({
//   //   client_id:
//   //     "3261615192-a7b1990p7trsciq2ggqjm541et754sbi.apps.googleusercontent.com",
//   //   // login_uri,
//   //   ux_mode: "popup",
//   //   callback: handleCredentialResponse,
//   // });
//   // google.accounts.id.renderButton(document.getElementById("google-join-btn"), {
//   //   type: "standard",
//   //   theme: "outline",
//   //   shape: "circle",
//   //   text: "구글 계정으로 회원가입",
//   //   width: "210px",
//   // });
//   // google.accounts.id.renderButton(document.getElementById("google-login-btn"), {
//   //   type: "icon",
//   //   theme: "outline",
//   //   shape: "circle",
//   // });
//   // google.accounts.id.prompt();
// }

// function handleCredentialResponse(response) {
//   console.log("handleCredentialResponse");
//   console.log("response", response);
//   if (response.credential) {
//     window["angularComponentRef"].zone.run(() => {
//       window["angularComponentRef"].loginResult({
//         socialKeyTypeCode: "Google",
//         socialToken: response.credential,
//       });
//     });
//   }
// }
